<template>
  <img :src="imageSource" v-if="imageSource" :id="imageId" :class="imageClass" :style="imageStyle">
</template>

<script>
export default {
  name: "dynamicImage",

  props: ["fileId", "imageId", "imageClass", "imageStyle", "fileUrl"],

  data() {
    return {
      imageSource: null,
    };
  },

  async mounted() {
    if (this.fileId) {
      if (this.device && this.device.platform == "iOS") {
        this.imageSource = await this.$store.dispatch("getFileUrl", this.fileId);
      } else {
        this.imageSource = this.baseUrl + "/file/" + this.fileId;
      }
    } else if (this.fileUrl) {
      this.imageSource = this.fileUrl
    }
  },
  watch: {
    fileId: async function (value) {
      if (value) {
        this.imageSource = this.baseUrl + "/file/" + value;
      }
    },
  },
};
</script>
